import { createStore } from 'vuex';
import auth from './modules/auth';
import chat from './modules/chat';
import notificationsModule from './modules/notifications';

export default createStore({
  modules: {
    auth,
    chat,
    notifications: notificationsModule,
  },
});
